import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import reportWebVitals from './reportWebVitals'
import PortfolioPage from './components/PortfolioPage'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <PortfolioPage />
  </React.StrictMode>
)

reportWebVitals()
